import { FC } from 'react'
import { Outlet, useMatch } from 'react-router-dom'
import { useUser } from '@clerk/clerk-react'
import { toast } from 'sonner'
import './card.css'

// COMPONENTS
import { Column } from '@components/templates/column'
import MyCardDetails from '@components/organisims/my-card-details'

// ROUTES
import { UserCardDefaultRoute } from './default'
import { AddCardBillingRoute } from './add-billing'
import { UpdateCardBillingRoute } from './update-billing'

// TYPES
import type { RouteObject } from 'react-router-dom'

// UTILITIES
import { parseTeraUserData } from '@schemas'
import { createAuthenticatedLoader, useLoader } from '@utils/loaders'


const Component: FC<{}> = () => {
    const { physicalCard } = useLoader<typeof loader>()
    const { user } = useUser()

    const isDefaultRoute = useMatch('/account/physical-card')?.pattern.end || false

    return (<>
        <Column.Content className="account-card-screen">
            <div className='content'>
                <MyCardDetails cardId={physicalCard?.id} cardHolder={user} lastFour={physicalCard?.lastFour} physical={true} hidden={!isDefaultRoute} handleCopy={() => toast.success('Card number copied')} />
                <Outlet />
            </div>
        </Column.Content>
    </>)
}

const loader = createAuthenticatedLoader(async ({ }, Clerk) => parseTeraUserData(Clerk.user?.publicMetadata.tera))

const UserPhysicalCardRoute: RouteObject = {
    path: 'physical-card',
    Component,
    loader,
    children: [
        UserCardDefaultRoute,
        AddCardBillingRoute,
        UpdateCardBillingRoute
    ]
}

export { UserPhysicalCardRoute }